/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import DTOUpdateDEpPrPic from './DTOUpdateDEpPrPic';
import UpdateDepPrPicPresenter from './UpdateDepPrPicPresenter';
import { dependentsServices } from '../../../api/services/dependentsServices';
import { setAlldependentslist } from '../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice';
import { commonServices } from '../../../api/services/commonServices';
interface eventList {
  profilePic: any;
  Dep_id: any;
  isAttachmentSigned?: boolean;
}
const UpdateDepPrPicController = ({
  profilePic,
  Dep_id,
  isAttachmentSigned,
}: eventList) => {
  const { t } = useTranslation();
  const trans = t;
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const [docLink , setDocLink] = useState('');

  function getNewProfilePic(data: any) {
    updateProfilePic(data);
  }

  async function updateProfilePic(pic: any) {
    const empId: any = selector.emp_id;
    const formData = new FormData();

    formData.append('emp_id', empId);
    formData.append('dependent_id', Dep_id);
    formData.append('file', pic);
    await dependentsServices
      .updateProfilePic(formData)
      .then((response: any) => {
        if (response.response == 'success') {
          dispatch(setAlldependentslist(response.data));
          toast.success(trans('Profile Picture Updated'));
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  }
  useEffect(() => {
    getfilepsth();
  }, [profilePic]);
  async function getfilepsth() {
    if (isAttachmentSigned) {
      setDocLink(profilePic);
    } else {
      const user_id: any = selector.user_id;
      const companyID: any = selector.company_id;
      const Payload = {
        filepath: profilePic,
        fullpath: true,
      };
      await commonServices
        .getFilePath(companyID, user_id, Payload)
        .then((res: any) => {
          setDocLink(res?.signed_path);
        });
    }
  }
  return (
    <div>
      <DTOUpdateDEpPrPic />
      <UpdateDepPrPicPresenter
        profilePic={docLink}
        setNewProfilePic={getNewProfilePic}
      />
    </div>
  );
};

export default UpdateDepPrPicController;
